import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Cached as CachedIcon, Nfc as NfcIcon } from "@mui/icons-material";

import CardTable from "../../components/CardTable/CardTable";
import { ModalV2 } from "../../components/Modal/ModalV2";
import RegularButton from "../../components/CustomButtons/Button";

import { useSearch } from "../../hooks/useSearch";
import { useToggle } from "../../hooks/useToggle";
import { useRevalidateFetch } from "../../hooks/useRevalidateFetch";

import { getNfcTags } from "../../redux/actions/nfcTags/nfcTagsAction";

import { columns } from "./columns";
import { NfcTagForm } from "./NfcTagForm";

const NfcTagsView = () => {
  const tableKey = "nfcTags";
  const dispatch = useDispatch();
  const { nfcTags } = useSelector(({ nfcTags }) => nfcTags);
  const { isLoadingComp, configTables } = useSelector(({ search }) => search);
  const { buildCompLoadings, buildTableConfig } = useSearch();
  const [open, setOpen] = useToggle();

  useRevalidateFetch(getNfcTags, nfcTags);

  useEffect(() => {
    buildCompLoadings(["loadingNfcTags"]);
    !configTables?.nfcTags && buildTableConfig(tableKey);
  }, []);

  return (
    <>
      <CardTable
        hasHeader
        title="NFC Tags"
        icon={<NfcIcon />}
        columns={columns}
        data={nfcTags}
        isLoading={isLoadingComp?.loadingNfcTags}
        tableKey={tableKey}
        blockBtn
        hasControl
        controls={
          <>
            <RegularButton
              justIcon
              round
              color="info"
              onClick={() => dispatch(getNfcTags())}
              tooltip="Refrescar"
              loading={isLoadingComp?.loadingNfcTags}
              size="sm"
            >
              <CachedIcon style={{ margin: 0 }} />
            </RegularButton>
            <RegularButton
              justIcon
              round
              color="info"
              onClick={setOpen}
              size="sm"
            >
              +
            </RegularButton>
          </>
        }
      />
      <ModalV2 title="Create NFC Tag" open={open} onClose={setOpen} toRight>
        <NfcTagForm onClose={setOpen} />
      </ModalV2>
    </>
  );
};

export default NfcTagsView;
